import { reskinStyles } from '../theme-variant';

const overrideTable = (theme) => {
  theme.overrides.MuiTableSortLabel = {
    root: {
      color: theme.colors.text_secondary,
      fontSize: 10,
      textTransform: 'uppercase',
      lineHeight: '14px',
      height: 14,
      // Reskin: the label renders at 12px with a scaled line height, so the fixed height would clip it.
      ...reskinStyles(theme, { height: 'auto' }),
      '&:hover': {
        color: theme.colors.text_primary
      }
    },
    icon: {
      position: 'absolute',
      margin: 0,
      left: -20
    },
    active: {
      color: theme.colors.text_primary
    }
  };
  theme.overrides.MuiTableCell = {
    root: {
      padding: theme.spacing(1, 5),
      fontSize: 16,
      borderBottom: `1px solid ${theme.colors.table_row_divider}`,
      '&$head': {
        color: theme.colorPalette.green_75
      }
    },
    body: {},
    head: {}
  };
  theme.overrides.MuiTableRow = {
    root: {
      position: 'relative',
      ...reskinStyles(theme, {
        '&:last-child > td': { borderBottom: 0 },
        '&$hover:hover': { backgroundColor: theme.colorPalette.beige_50 }
      })
    },
    hover: {}
  };
  theme.overrides.MuiTablePagination = {
    caption: {
      textTransform: 'uppercase'
    },
    selectIcon: {
      top: 11
    }
  };
};

export default overrideTable;
